"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _commonPricings = require("./commonPricings");
var _sofaCreation = require("./sofaCreation");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// *** Version: 12 ***

/* eslint max-len: 0, object-curly-newline: 0 */

/** @param { import("../entities/types").RawPricingPiece } rawPricing */
var rawPricing = [{
  name: 'Manteau & veste',
  slug: 'mant',
  types: undefined,
  hasMostCommonCategory: true,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mant-ret-cin-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          DEFAULT: 59
        },
        id: '12.mant-ret-cin-2'
      }, {
        name: 'Taille',
        prices: {
          DEFAULT: 37
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mant-ret-cin-3'
      }, {
        name: 'Dos',
        prices: {
          DEFAULT: 20
        },
        liningPrices: {
          DEFAULT: 7
        },
        id: '12.mant-ret-cin-4',
        mostCommonCategoryPosition: 2,
        mostCommonCategoryLabel: 'Cintrer dos'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          DEFAULT: 52
        },
        liningPrices: {
          DEFAULT: 18
        },
        id: '12.mant-ret-ela-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          DEFAULT: 64
        },
        id: '12.mant-ret-ela-2'
      }, {
        name: 'Taille',
        prices: {
          DEFAULT: 46
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mant-ret-ela-3'
      }, {
        name: 'Dos',
        prices: {
          DEFAULT: 25
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mant-ret-ela-4'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          DEFAULT: 29
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mant-ret-rac-1',
        mostCommonCategoryPosition: 1,
        mostCommonCategoryLabel: 'Raccourcir longueur'
      }, {
        name: 'Manche (x2 - par le bas)',
        prices: {
          DEFAULT: 25
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-ret-rac-2'
      }, {
        name: 'Manche (x2 - par l’épaule)',
        prices: {
          DEFAULT: 65
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mant-ret-rac-3'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          DEFAULT: 35
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mant-ret-ral-1'
      }, {
        name: 'Manche (x2 - par le bas)',
        prices: {
          DEFAULT: 27
        },
        liningPrices: {
          DEFAULT: 25
        },
        id: '12.mant-ret-ral-2'
      }, {
        name: 'Manche (x2 - par l’épaule)',
        prices: {
          DEFAULT: 85
        },
        liningPrices: {
          DEFAULT: 25
        },
        id: '12.mant-ret-ral-3'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 24
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 37
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          DEFAULT: 4
        },
        liningPrices: {
          DEFAULT: 1
        },
        id: '12.mant-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '12.mant-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mant-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '12.mant-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mant-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mant-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 6
        },
        id: '12.mant-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mant-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          DEFAULT: 12
        },
        id: '12.mant-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          DEFAULT: 18
        },
        id: '12.mant-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          DEFAULT: 17
        },
        id: '12.mant-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          DEFAULT: 17
        },
        id: '12.mant-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          DEFAULT: 15
        },
        id: '12.mant-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          DEFAULT: 19
        },
        id: '12.mant-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          DEFAULT: 22
        },
        id: '12.mant-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          DEFAULT: 9
        },
        id: '12.mant-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          DEFAULT: 11
        },
        id: '12.mant-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mant-ret-div-13',
        multiple: true
      }, {
        name: 'Doublure : changement intégral',
        prices: {
          DEFAULT: 105
        },
        id: '12.mant-ret-div-14'
      }, {
        name: 'Doublure : changement partiel',
        prices: {
          DEFAULT: 45
        },
        id: '12.mant-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          DEFAULT: 2
        },
        id: '12.mant-ret-div-16',
        multiple: true
      }, {
        name: 'Épaulettes (x2) : ajout / remplacement / retrait',
        prices: {
          DEFAULT: 21
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '12.mant-ret-div-17'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          DEFAULT: 6
        },
        multiple: true,
        id: '12.mant-ret-div-18',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          DEFAULT: 12
        },
        multiple: true,
        id: '12.mant-ret-div-19',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [{
      name: 'Déchirures / trous',
      slug: 'tear_repair',
      items: [{
        name: 'Déchirure : réparation',
        prices: {
          DEFAULT: 16
        },
        id: '12.mant-rep-tear-1',
        multiple: true,
        repairBonus: 'HOLE',
        mostCommonCategoryPosition: 5
      }, {
        name: 'Couture complexe avec empiècement',
        prices: {
          DEFAULT: 17
        },
        id: '12.mant-rep-tear-2',
        multiple: true,
        repairBonus: 'HOLE'
      }, {
        name: 'Trou : raccommodage simple',
        prices: {
          DEFAULT: 12
        },
        id: '12.mant-rep-tear-4',
        multiple: true,
        repairBonus: 'HOLE'
      }, {
        name: 'Trou : raccommodage complexe',
        prices: {
          DEFAULT: 17
        },
        multiple: true,
        id: '12.mant-rep-tear-5',
        repairBonus: 'HOLE'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_repair',
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 24
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-1',
        multiple: true,
        repairBonus: 'ZIP_SMALL',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 37
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-2',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-3',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 28
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-4',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 55
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-5',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 19
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-6',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 40
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-7',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 23
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-8',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 48
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-9',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 48
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-10',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 35
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-11',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 42
        },
        liningPrices: {
          DEFAULT: 5
        },
        id: '12.mant-rep-zip-12',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }]
    }, {
      name: 'Boutons',
      slug: 'but_repair',
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          DEFAULT: 4
        },
        liningPrices: {
          DEFAULT: 1
        },
        id: '12.mant-rep-but-1',
        multiple: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '12.mant-rep-but-2',
        multiple: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mant-rep-but-4',
        multiple: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '12.mant-rep-but-5',
        multiple: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mant-rep-but-6',
        multiple: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mant-rep-but-7',
        multiple: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 6
        },
        id: '12.mant-rep-but-8',
        multiple: true
      }]
    }, {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          DEFAULT: 4
        },
        id: '12.mant-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          DEFAULT: 14
        },
        id: '12.mant-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          DEFAULT: 14
        },
        id: '12.mant-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 4
        },
        id: '12.mant-rep-div-5'
      }, {
        name: 'Coudière / genouillère (x2)',
        prices: {
          DEFAULT: 20
        },
        id: '12.mant-rep-div-6',
        repairBonus: 'HOLE'
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          DEFAULT: 19
        },
        id: '12.mant-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mant-rep-div-9'
      }, {
        name: 'Doublure : changement intégral',
        prices: {
          DEFAULT: 105
        },
        id: '12.mant-rep-div-10',
        repairBonus: 'LINING_COMPLEX'
      }, {
        name: 'Doublure : changement partiel',
        prices: {
          DEFAULT: 45
        },
        id: '12.mant-rep-div-11',
        repairBonus: 'LINING_COMPLEX',
        mostCommonCategoryPosition: 3
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('mant', 'SIMPLE'), {
      name: 'Broderie machine',
      slug: 'machine_embroidery',
      items: [{
        name: 'Texte (15 lettres maximum) ≤ 0.5cm',
        prices: {
          DEFAULT: 12
        },
        id: '12.mant-bro-15',
        multiple: true
      }, {
        name: 'Texte (15 lettres maximum) ≤ 2cm',
        prices: {
          DEFAULT: 15
        },
        id: '12.mant-bro-16',
        multiple: true
      }, {
        name: 'Texte (15 lettres maximum) ≤ 3cm',
        prices: {
          DEFAULT: 20
        },
        id: '12.mant-bro-17',
        multiple: true
      }, {
        name: 'Dessin creux ≤ 0.5cm',
        prices: {
          DEFAULT: 12
        },
        id: '12.mant-bro-18',
        multiple: true
      }, {
        name: 'Dessin creux ≤ 2cm',
        prices: {
          DEFAULT: 15
        },
        id: '12.mant-bro-19',
        multiple: true
      }, {
        name: 'Dessin creux ≤ 3cm',
        prices: {
          DEFAULT: 20
        },
        id: '12.mant-bro-20',
        multiple: true
      }]
    }]
  }]
}, {
  name: 'Haut',
  slug: 'haut',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 14,
          COMPLEX: 29
        },
        id: '12.haut-ret-cin-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 14,
          COMPLEX: 29
        },
        id: '12.haut-ret-cin-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 14,
          COMPLEX: 25
        },
        id: '12.haut-ret-cin-3'
      }, {
        name: 'Dos',
        type: 'SIMPLE',
        prices: {
          SIMPLE: 9,
          COMPLEX: 18
        },
        id: '12.haut-ret-cin-4',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer dos'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 28
        },
        id: '12.haut-ret-ela-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '12.haut-ret-ela-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '12.haut-ret-ela-3'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 10,
          COMPLEX: 20
        },
        id: '12.haut-ret-ela-4'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 8,
          COMPLEX: 21
        },
        id: '12.haut-ret-rac-1',
        mostCommonCategoryPosition: 4,
        mostCommonCategoryLabel: 'Raccourcir longueur'
      }, {
        name: 'Manches (x2 - par le bas)',
        prices: {
          SIMPLE: 10,
          COMPLEX: 23
        },
        id: '12.haut-ret-rac-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        prices: {
          SIMPLE: 28,
          COMPLEX: 65
        },
        id: '12.haut-ret-rac-3'
      }, {
        name: 'Bretelles (x2 - par l’épaule)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 18
        },
        id: '12.haut-ret-rac-7'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 10,
          COMPLEX: 24
        },
        id: '12.haut-ret-ral-1'
      }, {
        name: 'Manches (x2 - par le bas)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 27
        },
        id: '12.haut-ret-ral-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        prices: {
          SIMPLE: 30,
          COMPLEX: 75
        },
        id: '12.haut-ret-ral-3'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.haut-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.haut-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.haut-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.haut-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.haut-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.haut-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.haut-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.haut-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.haut-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.haut-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.haut-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.haut-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.haut-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.haut-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.haut-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.haut-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.haut-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.haut-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.haut-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.haut-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.haut-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.haut-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.haut-ret-div-14'
      }, {
        name: 'Épaulettes (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.haut-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.haut-ret-div-16'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.haut-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.haut-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'haut',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZips)({
      slug: 'haut',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'haut',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.haut-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.haut-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED',
        mostCommonCategoryPosition: 3
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.haut-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.haut-rep-div-5'
      }, {
        name: 'Coudière / genouillère (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '12.haut-rep-div-6',
        repairBonus: 'HOLE'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.haut-rep-div-7',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.haut-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.haut-rep-div-9'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('haut', undefined), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'haut'
    })]
  }]
}, {
  name: 'Pantalon',
  slug: 'pant',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Ceinture',
        prices: {
          SIMPLE: 42,
          COMPLEX: 32
        },
        liningPrices: {
          COMPLEX: 11
        },
        id: '12.pant-ret-cin-1'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 42,
          COMPLEX: 45
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.pant-ret-cin-2'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          COMPLEX: 8
        },
        id: '12.pant-ret-cin-3',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer bas de jambes'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 15,
          COMPLEX: 22
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.pant-ret-cin-4'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Ceinture',
        prices: {
          SIMPLE: 47,
          COMPLEX: 38
        },
        liningPrices: {
          COMPLEX: 12
        },
        id: '12.pant-ret-ela-1'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 47,
          COMPLEX: 50
        },
        liningPrices: {
          COMPLEX: 10
        },
        id: '12.pant-ret-ela-2'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 27,
          COMPLEX: 27
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.pant-ret-ela-3'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        liningPrices: {
          COMPLEX: 10
        },
        id: '12.pant-ret-ela-4'
      }]
    }, {
      name: 'Ourlets',
      slug: 'hem_alteration',
      items: [{
        name: 'Ourlet simple (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 17
        },
        liningPrices: {
          COMPLEX: 7
        },
        id: '12.pant-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet revers (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.pant-ret-rac-2'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.pant-ret-ral-1'
      }, {
        name: 'Ourlet (x2) : suppression des revers',
        prices: {
          COMPLEX: 17
        },
        liningPrices: {
          COMPLEX: 7
        },
        id: '12.pant-ret-ral-2'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.pant-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.pant-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.pant-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.pant-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.pant-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.pant-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.pant-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.pant-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.pant-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.pant-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 42,
          COMPLEX: 49
        },
        id: '12.pant-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.pant-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.pant-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.pant-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.pant-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.pant-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.pant-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.pant-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.pant-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.pant-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.pant-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.pant-ret-div-13',
        multiple: true
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.pant-ret-div-14',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.pant-ret-div-15',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'pant',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZips)({
      slug: 'pant',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'pant',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.pant-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.pant-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.pant-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.pant-rep-div-5'
      }, {
        name: 'Coudière / genouillère (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '12.pant-rep-div-6',
        repairBonus: 'HOLE'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 42,
          COMPLEX: 60
        },
        id: '12.pant-rep-div-7',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.pant-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.pant-rep-div-9'
      }, {
        name: 'Ourlet - décousu (x2 jambes)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.pant-rep-div-10',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('pant', undefined), (0, _commonPricings.getCommunMachineEmbroidery)({
      slug: 'pant'
    })]
  }]
}, {
  name: 'Jupe',
  slug: 'jupe',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.jupe-ret-cin-2'
      }, {
        name: 'Taille / ceinture',
        prices: {
          SIMPLE: 27,
          COMPLEX: 33
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 5
        },
        id: '12.jupe-ret-cin-1',
        mostCommonCategoryPosition: 5
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 25
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '12.jupe-ret-ela-1'
      }, {
        name: 'Taille / ceinture',
        prices: {
          SIMPLE: 29,
          COMPLEX: 35
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '12.jupe-ret-ela-2'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Ourlet simple',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.jupe-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet ample',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 18,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.jupe-ret-rac-2'
      }, {
        name: 'Ourlet à volants',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 22,
          COMPLEX: 28
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '12.jupe-ret-rac-3'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.jupe-ret-ral-1'
      }, {
        name: 'Longueur ample',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.jupe-ret-ral-2'
      }, {
        name: 'Longueur à volants',
        prices: {
          SIMPLE: 22,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.jupe-ret-ral-3'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.jupe-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.jupe-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.jupe-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.jupe-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.jupe-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.jupe-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.jupe-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.jupe-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.jupe-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.jupe-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 42,
          COMPLEX: 49
        },
        id: '12.jupe-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.jupe-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.jupe-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.jupe-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.jupe-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.jupe-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.jupe-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.jupe-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.jupe-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.jupe-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.jupe-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.jupe-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.jupe-ret-div-14'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.jupe-ret-div-15'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.jupe-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.jupe-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZips)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'jupe',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.jupe-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.jupe-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.jupe-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.jupe-rep-div-5'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 42,
          COMPLEX: 60
        },
        id: '12.jupe-rep-div-7',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.jupe-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.jupe-rep-div-9'
      }, {
        name: 'Ourlet - décousu',
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        id: '12.jupe-rep-div-10',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('jupe', undefined)]
  }]
}, {
  name: 'Robe',
  slug: 'robe',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.robe-ret-cin-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        id: '12.robe-ret-cin-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        id: '12.robe-ret-cin-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 32,
          COMPLEX: 34
        },
        id: '12.robe-ret-cin-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          SIMPLE: 25,
          COMPLEX: 33
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 5
        },
        id: '12.robe-ret-cin-5',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer taille'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 21,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.robe-ret-cin-6'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 23,
          COMPLEX: 26
        },
        liningPrices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.robe-ret-ela-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.robe-ret-ela-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 29
        },
        id: '12.robe-ret-ela-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 38
        },
        id: '12.robe-ret-ela-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          SIMPLE: 27,
          COMPLEX: 35
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 5
        },
        id: '12.robe-ret-ela-5'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 26,
          COMPLEX: 27
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '12.robe-ret-ela-6'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Ourlet simple',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.robe-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet ample',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 18,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.robe-ret-rac-2'
      }, {
        name: 'Ourlet à volants',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 22,
          COMPLEX: 28
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 6
        },
        id: '12.robe-ret-rac-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 16
        },
        id: '12.robe-ret-rac-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 26
        },
        id: '12.robe-ret-rac-5'
      }, {
        name: 'Bretelles (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 8,
          COMPLEX: 18
        },
        id: '12.robe-ret-rac-6'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.robe-ret-ral-1'
      }, {
        name: 'Longueur ample',
        prices: {
          SIMPLE: 20,
          COMPLEX: 23
        },
        liningPrices: {
          SIMPLE: 4,
          COMPLEX: 5
        },
        id: '12.robe-ret-ral-2'
      }, {
        name: 'Longueur à volants',
        prices: {
          SIMPLE: 22,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.robe-ret-ral-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 14,
          COMPLEX: 17
        },
        id: '12.robe-ret-ral-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 28
        },
        id: '12.robe-ret-ral-5'
      }, {
        name: 'Bretelles (x2)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        id: '12.robe-ret-ral-6'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.robe-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.robe-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.robe-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.robe-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.robe-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.robe-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.robe-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.robe-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.robe-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.robe-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 42,
          COMPLEX: 49
        },
        id: '12.robe-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.robe-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.robe-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.robe-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.robe-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.robe-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.robe-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.robe-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.robe-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.robe-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.robe-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.robe-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.robe-ret-div-14'
      }, {
        name: 'Épaulettes (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.robe-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.robe-ret-div-16'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.robe-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.robe-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'robe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZips)({
      slug: 'robe',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'robe',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.robe-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.robe-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.robe-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.robe-rep-div-5'
      }, {
        name: 'Coudière / genouillère (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '12.robe-rep-div-6',
        repairBonus: 'HOLE'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 42,
          COMPLEX: 60
        },
        id: '12.robe-rep-div-7',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.robe-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.robe-rep-div-9'
      }, {
        name: 'Ourlet - décousu',
        prices: {
          SIMPLE: 12,
          COMPLEX: 20
        },
        id: '12.robe-rep-div-10',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('robe', undefined)]
  }]
}, {
  name: 'Pull & gilet',
  slug: 'pull',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Laine & cachemire'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 16,
          COMPLEX: 40
        },
        id: '12.pull-ret-cin-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 18,
          COMPLEX: 45
        },
        id: '12.pull-ret-cin-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 52
        },
        id: '12.pull-ret-cin-3'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 18,
          COMPLEX: 45
        },
        id: '12.pull-ret-cin-4'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 11,
          COMPLEX: 27
        },
        id: '12.pull-ret-cin-5',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer dos'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 42
        },
        id: '12.pull-ret-ela-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 47
        },
        id: '12.pull-ret-ela-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          SIMPLE: 24,
          COMPLEX: 60
        },
        id: '12.pull-ret-ela-3'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 20,
          COMPLEX: 50
        },
        id: '12.pull-ret-ela-4'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 13,
          COMPLEX: 32
        },
        id: '12.pull-ret-ela-5'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 14,
          COMPLEX: 35
        },
        id: '12.pull-ret-rac-1'
      }, {
        name: 'Manches (x2 - par le bas)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 30
        },
        id: '12.pull-ret-rac-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        prices: {
          SIMPLE: 37,
          COMPLEX: 92
        },
        id: '12.pull-ret-rac-3'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur',
        prices: {
          SIMPLE: 17,
          COMPLEX: 42
        },
        id: '12.pull-ret-ral-1'
      }, {
        name: 'Manches (x2 - par le bas)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 30
        },
        id: '12.pull-ret-ral-2'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        prices: {
          SIMPLE: 37,
          COMPLEX: 92
        },
        id: '12.pull-ret-ral-3'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.pull-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.pull-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.pull-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.pull-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.pull-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.pull-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.pull-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.pull-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.pull-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.pull-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.pull-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.pull-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.pull-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.pull-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.pull-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.pull-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.pull-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.pull-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.pull-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.pull-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.pull-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.pull-ret-div-13',
        multiple: true
      }, {
        name: 'Épaulettes (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.pull-ret-div-14'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.pull-ret-div-15'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.pull-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.pull-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [{
      name: 'Déchirures / trous',
      slug: 'tear_repair',
      items: [{
        name: 'Déchirure : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 16
        },
        id: '12.pull-rep-tear-1',
        multiple: true,
        repairBonus: 'HOLE',
        isSuitableForJunior: true
      }, {
        name: 'Couture complexe avec empiècement',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.pull-rep-tear-2',
        multiple: true,
        repairBonus: 'HOLE',
        isSuitableForJunior: true
      }, {
        name: 'Trou : raccommodage simple',
        prices: {
          SIMPLE: 12,
          COMPLEX: 12
        },
        id: '12.pull-rep-tear-4',
        multiple: true,
        repairBonus: 'HOLE',
        isSuitableForJunior: true,
        mostCommonCategoryPosition: 1
      }, {
        name: 'Trou : raccommodage complexe',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        multiple: true,
        isSuitableForJunior: true,
        repairBonus: 'HOLE',
        id: '12.pull-rep-tear-5'
      }, {
        name: 'Trou : remaillage simple',
        prices: {
          SIMPLE: 25,
          COMPLEX: 25
        },
        id: '12.pull-rep-tear-6',
        multiple: true,
        repairBonus: 'HOLE'
      }, {
        name: 'Trou : remaillage complexe',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: '12.pull-rep-tear-7',
        multiple: true,
        repairBonus: 'HOLE'
      }]
    }, (0, _commonPricings.getCommunZips)({
      slug: 'pull',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'pull',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.pull-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.pull-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.pull-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.pull-rep-div-5'
      }, {
        name: 'Coudière / genouillère (x2)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '12.pull-rep-div-6',
        repairBonus: 'HOLE',
        mostCommonCategoryPosition: 2
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.pull-rep-div-7',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.pull-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.pull-rep-div-9'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('pull', undefined)]
  }]
}, {
  name: 'Lingerie & maillot',
  slug: 'ling',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Lingerie fine'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Tour de poitrine',
        prices: {
          SIMPLE: 9,
          COMPLEX: 22
        },
        id: '12.ling-ret-cin-1'
      }, {
        name: 'Bonnets (x2)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.ling-ret-cin-2'
      }, {
        name: 'Tour de taille',
        prices: {
          SIMPLE: 20,
          COMPLEX: 30
        },
        id: '12.ling-ret-cin-3'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Tour de poitrine',
        prices: {
          SIMPLE: 10,
          COMPLEX: 25
        },
        id: '12.ling-ret-ela-1'
      }, {
        name: 'Tour de taille',
        prices: {
          SIMPLE: 20,
          COMPLEX: 40
        },
        id: '12.ling-ret-ela-2'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Bretelles (x2)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 20
        },
        id: '12.ling-ret-rac-1'
      }, {
        name: 'Forme culotte / caleçon',
        prices: {
          SIMPLE: 20,
          COMPLEX: 30
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.ling-ret-rac-2'
      }, {
        name: 'Ourlet',
        prices: {
          SIMPLE: 12
        },
        liningPrices: {
          SIMPLE: 2
        },
        id: '12.ling-ret-rac-3',
        mostCommonCategoryPosition: 5
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Bretelles (x2)',
        prices: {
          SIMPLE: 9,
          COMPLEX: 22
        },
        id: '12.ling-ret-ral-1'
      }, {
        name: 'Forme culotte / caleçon',
        prices: {
          SIMPLE: 22,
          COMPLEX: 35
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.ling-ret-ral-2'
      }, {
        name: 'Longueur',
        prices: {
          SIMPLE: 14
        },
        liningPrices: {
          SIMPLE: 3
        },
        id: '12.ling-ret-ral-3'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.ling-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.ling-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.ling-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.ling-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.ling-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.ling-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.ling-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.ling-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.ling-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.ling-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.ling-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.ling-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.ling-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.ling-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.ling-ret-div-6',
        mostCommonCategoryPosition: 3
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.ling-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.ling-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.ling-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.ling-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.ling-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.ling-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.ling-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.ling-ret-div-14'
      }, {
        name: 'Attache dos : remplacement',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        multiple: true,
        id: '12.ling-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.ling-ret-div-16'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.ling-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.ling-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'ling'
    }), (0, _commonPricings.getCommunZips)({
      slug: 'ling'
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'ling'
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.ling-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.ling-rep-div-3',
        multiple: true,
        mostCommonCategoryPosition: 2
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.ling-rep-div-4',
        multiple: true
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.ling-rep-div-5'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.ling-rep-div-7'
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.ling-rep-div-8'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.ling-rep-div-9'
      }, {
        name: 'Baleines (x2) : remplacement / réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 17
        },
        liningPrices: {
          SIMPLE: 8,
          COMPLEX: 17
        },
        multiple: true,
        id: '12.ling-rep-div-10'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('ling', undefined)]
  }]
}, {
  name: 'Combinaison',
  slug: 'comb',
  hasMostCommonCategory: true,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 14.5,
          COMPLEX: 29
        },
        id: '12.comb-ret-cin-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 14.5,
          COMPLEX: 29
        },
        id: '12.comb-ret-cin-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 14.5,
          COMPLEX: 25
        },
        id: '12.comb-ret-cin-3'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 9,
          COMPLEX: 18
        },
        id: '12.comb-ret-cin-4'
      }, {
        name: 'Ceinture',
        prices: {
          SIMPLE: 32,
          COMPLEX: 42
        },
        liningPrices: {
          COMPLEX: 11
        },
        id: '12.comb-ret-cin-5'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 42,
          COMPLEX: 45
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.comb-ret-cin-6'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          COMPLEX: 8
        },
        id: '12.comb-ret-cin-7',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer bas de jambes'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 15,
          COMPLEX: 22
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.comb-ret-cin-8'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Épaules (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '12.comb-ret-ela-1'
      }, {
        name: 'Manches (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 32
        },
        id: '12.comb-ret-ela-2'
      }, {
        name: 'Taille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 28
        },
        id: '12.comb-ret-ela-3'
      }, {
        name: 'Dos',
        prices: {
          SIMPLE: 10,
          COMPLEX: 20
        },
        id: '12.comb-ret-ela-4'
      }, {
        name: 'Ceinture',
        prices: {
          SIMPLE: 38,
          COMPLEX: 47
        },
        liningPrices: {
          COMPLEX: 12
        },
        id: '12.comb-ret-ela-5'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 47,
          COMPLEX: 50
        },
        liningPrices: {
          COMPLEX: 10
        },
        id: '12.comb-ret-ela-6'
      }, {
        name: 'Bas de jambes (x2)',
        prices: {
          SIMPLE: 27,
          COMPLEX: 27
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.comb-ret-ela-7'
      }, {
        name: 'Entrejambe',
        prices: {
          SIMPLE: 20,
          COMPLEX: 27
        },
        liningPrices: {
          COMPLEX: 10
        },
        id: '12.comb-ret-ela-8'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Manches (x2 - par le bas)',
        prices: {
          SIMPLE: 10,
          COMPLEX: 23
        },
        id: '12.comb-ret-rac-1'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        prices: {
          SIMPLE: 28,
          COMPLEX: 65
        },
        id: '12.comb-ret-rac-2'
      }, {
        name: 'Ourlet simple (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 12,
          COMPLEX: 17
        },
        liningPrices: {
          COMPLEX: 7
        },
        id: '12.comb-ret-rac-3',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet revers (x2)',
        isSuitableForJunior: true,
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.comb-ret-rac-4'
      }, {
        name: 'Bretelles (x2 - par l’épaule)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 18
        },
        id: '12.comb-ret-rac-9'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Manches (x2 - par le bas)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 27
        },
        id: '12.comb-ret-ral-1'
      }, {
        name: 'Manches (x2 - par l’épaule)',
        prices: {
          SIMPLE: 30,
          COMPLEX: 75
        },
        id: '12.comb-ret-ral-2'
      }, {
        name: 'Jambes (x2)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 20
        },
        liningPrices: {
          COMPLEX: 9
        },
        id: '12.comb-ret-ral-3'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.comb-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.comb-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.comb-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.comb-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.comb-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.comb-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.comb-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.comb-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.comb-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.comb-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.comb-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.comb-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.comb-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.comb-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.comb-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.comb-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.comb-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.comb-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.comb-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.comb-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.comb-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.comb-ret-div-13',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.comb-ret-div-14'
      }, {
        name: 'Épaulettes (x2) : ajout / remplacement / retrait',
        prices: {
          SIMPLE: 18,
          COMPLEX: 21
        },
        liningPrices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.comb-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.comb-ret-div-16'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.com-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.com-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'comb',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZips)({
      slug: 'comb',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'comb',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.comb-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.comb-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.comb-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.comb-rep-div-5'
      }, {
        name: 'Coudière / genouillère (x2)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 20
        },
        id: '12.comb-rep-div-6',
        repairBonus: 'HOLE'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 35,
          COMPLEX: 55
        },
        id: '12.comb-rep-div-7',
        repairBonus: {
          SIMPLE: 'LINING_SIMPLE',
          COMPLEX: 'LINING_COMPLEX'
        }
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.comb-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.comb-rep-div-9'
      }, {
        name: 'Ourlet - décousu (x2 jambes)',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.comb-rep-div-10',
        repairBonus: 'UNTIED_UNLINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('comb', undefined)]
  }]
}, {
  name: 'Robe de mariée',
  slug: 'mari',
  hasMostCommonCategory: true,
  types: undefined,
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Cintrer',
      slug: 'cin_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 28
        },
        id: '12.mari-ret-cin-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          DEFAULT: 42
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-cin-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 49
        },
        id: '12.mari-ret-cin-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 63
        },
        id: '12.mari-ret-cin-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          DEFAULT: 70
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-cin-5',
        mostCommonCategoryPosition: 5,
        mostCommonCategoryLabel: 'Cintrer taille'
      }, {
        name: 'Dos',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-cin-6'
      }]
    }, {
      name: 'Élargir',
      slug: 'ela_alteration',
      items: [{
        name: 'Côtés (x2)',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 28
        },
        id: '12.mari-ret-ela-1'
      }, {
        name: 'Épaules (x2)',
        prices: {
          DEFAULT: 42
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-ela-2'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 49
        },
        id: '12.mari-ret-ela-3'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 63
        },
        id: '12.mari-ret-ela-4'
      }, {
        name: 'Bustier / taille',
        prices: {
          DEFAULT: 70
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-ela-5'
      }, {
        name: 'Dos',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-ela-6'
      }]
    }, {
      name: 'Raccourcir',
      slug: 'rac_alteration',
      items: [{
        name: 'Ourlet simple',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-ret-rac-1',
        mostCommonCategoryPosition: 1
      }, {
        name: 'Ourlet à volants',
        prices: {
          DEFAULT: 84
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mari-ret-rac-2'
      }, {
        name: 'Ourlet revers',
        prices: {
          DEFAULT: 65
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-ret-rac-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 23
        },
        id: '12.mari-ret-rac-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 32
        },
        id: '12.mari-ret-rac-5'
      }, {
        name: 'Bretelles (x2)',
        prices: {
          DEFAULT: 28
        },
        id: '12.mari-ret-rac-6'
      }]
    }, {
      name: 'Rallonger',
      slug: 'ral_alteration',
      items: [{
        name: 'Longueur simple',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-ret-ral-1'
      }, {
        name: 'Longueur à volants',
        prices: {
          DEFAULT: 84
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mari-ret-ral-2'
      }, {
        name: 'Ourlets (x2) : suppression des revers',
        prices: {
          DEFAULT: 59
        },
        liningPrices: {
          DEFAULT: 11
        },
        id: '12.mari-ret-ral-3'
      }, {
        name: 'Manches (x2 - sans boutonnière)',
        prices: {
          DEFAULT: 23
        },
        id: '12.mari-ret-ral-4'
      }, {
        name: 'Manches (x2 - boutonnière)',
        prices: {
          DEFAULT: 32
        },
        id: '12.mari-ret-ral-5'
      }, {
        name: 'Bretelles (x2)',
        prices: {
          DEFAULT: 28
        },
        id: '12.mari-ret-ral-6'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 30
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          DEFAULT: 62
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mari-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          DEFAULT: 10
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '12.mari-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 4
        },
        id: '12.mari-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mari-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '12.mari-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mari-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 6
        },
        id: '12.mari-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          DEFAULT: 69
        },
        id: '12.mari-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 10
        },
        id: '12.mari-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          DEFAULT: 25
        },
        id: '12.mari-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          DEFAULT: 29
        },
        id: '12.mari-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          DEFAULT: 22
        },
        id: '12.mari-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          DEFAULT: 35
        },
        id: '12.mari-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          DEFAULT: 18
        },
        id: '12.mari-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          DEFAULT: 22
        },
        id: '12.mari-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          DEFAULT: 27
        },
        id: '12.mari-ret-div-10',
        multiple: true
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 10
        },
        id: '12.mari-ret-div-12',
        multiple: true
      }, {
        name: 'Bretelles (x2) : ajout / remplacement / retrait',
        prices: {
          DEFAULT: 18
        },
        id: '12.mari-ret-div-13'
      }, {
        name: 'Épaulettes (x2) : ajout / remplacement / retrait',
        prices: {
          DEFAULT: 35
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-ret-div-14'
      }, {
        name: 'Ceinture : ajout / remplacement',
        prices: {
          DEFAULT: 42
        },
        multiple: true,
        id: '12.mari-ret-div-15'
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          DEFAULT: 2
        },
        multiple: true,
        id: '12.mari-ret-div-16'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          DEFAULT: 17
        },
        multiple: true,
        id: '12.mari-ret-div-17',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          DEFAULT: 19
        },
        multiple: true,
        id: '12.mari-ret-div-18',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [{
      name: 'Déchirures / trous',
      slug: 'tear_repair',
      items: [{
        name: 'Déchirure : réparation',
        prices: {
          DEFAULT: 21
        },
        liningPrices: {
          DEFAULT: 8
        },
        id: '12.mari-rep-tear-1',
        multiple: true,
        repairBonus: 'HOLE',
        mostCommonCategoryPosition: 3
      }, {
        name: 'Couture complexe avec empiècement',
        prices: {
          DEFAULT: 35
        },
        id: '12.mari-rep-tear-2',
        multiple: true,
        repairBonus: 'HOLE'
      }, {
        name: 'Trou : raccommodage simple',
        prices: {
          DEFAULT: 12
        },
        id: '12.mari-rep-tear-3',
        multiple: true,
        repairBonus: 'HOLE'
      }, {
        name: 'Trou : raccommodage complexe',
        prices: {
          DEFAULT: 17
        },
        id: '12.mari-rep-tear-4',
        multiple: true,
        repairBonus: 'HOLE'
      }]
    }, {
      name: 'Zips',
      slug: 'zip_repair',
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 30
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-zip-1',
        multiple: true,
        repairBonus: 'ZIP_SMALL',
        mostCommonCategoryPosition: 2
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-zip-2',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 62
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mari-rep-zip-3',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 56
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mari-rep-zip-4',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 63
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mari-rep-zip-5',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-zip-6',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 53
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mari-rep-zip-7',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 12
        },
        id: '12.mari-rep-zip-8',
        multiple: true,
        repairBonus: 'ZIP_SMALL'
      }, {
        name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 50
        },
        liningPrices: {
          DEFAULT: 15
        },
        id: '12.mari-rep-zip-9',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
        prices: {
          DEFAULT: 60
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-zip-10',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 43
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-zip-11',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }, {
        name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
        prices: {
          DEFAULT: 47
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-zip-12',
        multiple: true,
        repairBonus: 'ZIP_BIG'
      }]
    }, {
      name: 'Boutons',
      slug: 'but_repair',
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          DEFAULT: 10
        },
        liningPrices: {
          DEFAULT: 2
        },
        id: '12.mari-rep-but-1',
        multiple: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 4
        },
        id: '12.mari-rep-but-2',
        multiple: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mari-rep-but-4',
        multiple: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 3
        },
        id: '12.mari-rep-but-5',
        multiple: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 2
        },
        id: '12.mari-rep-but-6',
        multiple: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          DEFAULT: 8
        },
        id: '12.mari-rep-but-7',
        multiple: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          DEFAULT: 6
        },
        id: '12.mari-rep-but-8',
        multiple: true
      }]
    }, {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          DEFAULT: 4
        },
        id: '12.mari-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          DEFAULT: 17
        },
        id: '12.mari-rep-div-3',
        multiple: true,
        repairBonus: 'UNTIED_LINED',
        mostCommonCategoryPosition: 4
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          DEFAULT: 19
        },
        id: '12.mari-rep-div-4',
        multiple: true,
        repairBonus: 'UNTIED_LINED'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 10
        },
        id: '12.mari-rep-div-5'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          DEFAULT: 69
        },
        id: '12.mari-rep-div-7',
        repairBonus: 'LINING_COMPLEX'
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          DEFAULT: 21
        },
        id: '12.mari-rep-div-8',
        repairBonus: 'LINING_SIMPLE'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          DEFAULT: 10
        },
        id: '12.mari-rep-div-9'
      }, {
        name: 'Ourlet - décousu',
        prices: {
          DEFAULT: 25
        },
        liningPrices: {
          DEFAULT: 13
        },
        id: '12.mari-rep-div-10',
        repairBonus: 'UNTIED_LINED'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('mari', 'mari')]
  }]
}, {
  name: 'Accessoires',
  slug: 'acce',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Retoucher',
    slug: 'alteration',
    subCategories: [{
      name: 'Zips',
      slug: 'zip_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 22,
          COMPLEX: 24
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.acce-ret-zip-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 35,
          COMPLEX: 37
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.acce-ret-zip-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
        prices: {
          SIMPLE: 45,
          COMPLEX: 47
        },
        liningPrices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '12.acce-ret-zip-3',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Boutons',
      slug: 'but_alteration',
      onlyCouturiers: true,
      items: [{
        name: 'Boutonnière (x1) : création',
        prices: {
          SIMPLE: 3,
          COMPLEX: 4
        },
        liningPrices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        id: '12.acce-ret-but-1',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.acce-ret-but-2',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.acce-ret-but-4',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: '12.acce-ret-but-5',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        id: '12.acce-ret-but-6',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        id: '12.acce-ret-but-7',
        multiple: true,
        onlyCouturiers: true
      }, {
        name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 6
        },
        id: '12.acce-ret-but-8',
        multiple: true,
        onlyCouturiers: true
      }]
    }, {
      name: 'Plus de retouches',
      slug: 'more_alteration',
      items: [{
        name: 'Doublure : retouche / ajout / retrait',
        prices: {
          SIMPLE: 9,
          COMPLEX: 12
        },
        id: '12.acce-ret-div-1'
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.acce-ret-div-3',
        multiple: true
      }, {
        name: 'Pince (x1) : ajout',
        prices: {
          SIMPLE: 8,
          COMPLEX: 12
        },
        id: '12.acce-ret-div-4',
        multiple: true
      }, {
        name: 'Fente : ajout / retrait',
        prices: {
          SIMPLE: 12,
          COMPLEX: 18
        },
        id: '12.acce-ret-div-5'
      }, {
        name: 'Élastique : ajout',
        prices: {
          SIMPLE: 7,
          COMPLEX: 17
        },
        id: '12.acce-ret-div-6'
      }, {
        name: 'Perlage (5 à 10 perles)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 17
        },
        id: '12.acce-ret-div-7',
        multiple: true
      }, {
        name: 'Poche plate simple (x1) : ajout',
        prices: {
          SIMPLE: 10,
          COMPLEX: 15
        },
        id: '12.acce-ret-div-8',
        multiple: true
      }, {
        name: 'Poche intérieure classique (x1) : ajout',
        prices: {
          SIMPLE: 15,
          COMPLEX: 19
        },
        id: '12.acce-ret-div-9',
        multiple: true
      }, {
        name: 'Poche complexe (x1) : ajout',
        prices: {
          SIMPLE: 20,
          COMPLEX: 22
        },
        id: '12.acce-ret-div-10',
        multiple: true
      }, {
        name: 'Scratch < 30cm',
        prices: {
          SIMPLE: 5,
          COMPLEX: 9
        },
        id: '12.acce-ret-div-11'
      }, {
        name: 'Scratch > 30cm',
        prices: {
          SIMPLE: 7,
          COMPLEX: 11
        },
        id: '12.acce-ret-div-12'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.acce-ret-div-13',
        multiple: true
      }, {
        name: 'Oeillet petit (x1) : ajout',
        prices: {
          SIMPLE: 1,
          COMPLEX: 1
        },
        multiple: true,
        id: '12.acce-ret-div-14'
      }, {
        name: 'Oeillet moyen (x1) : ajout',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        multiple: true,
        id: '12.acce-ret-div-15'
      }, {
        name: 'Couture de finition simple : retouche',
        prices: {
          SIMPLE: 4,
          COMPLEX: 6
        },
        multiple: true,
        id: '12.acce-ret-div-16',
        mostCommonCategoryPosition: 6,
        onlyCouturiers: true
      }, {
        name: 'Couture de finition complexe : retouche',
        prices: {
          SIMPLE: 10,
          COMPLEX: 12
        },
        multiple: true,
        id: '12.acce-ret-div-17',
        mostCommonCategoryPosition: 7,
        onlyCouturiers: true
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'repair',
    subCategories: [(0, _commonPricings.getCommunTear)({
      slug: 'acce',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunZips)({
      slug: 'acce',
      isSuitableForJunior: true
    }), (0, _commonPricings.getCommunButtons)({
      slug: 'acce',
      isSuitableForJunior: true
    }), {
      name: 'Plus de réparations',
      slug: 'more_repair',
      items: [{
        name: 'Petit trou / raccommodage',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        id: '12.acce-rep-div-1',
        multiple: true
      }, {
        name: 'Couture décousue simple : réparation',
        prices: {
          SIMPLE: 12,
          COMPLEX: 14
        },
        id: '12.acce-rep-div-3',
        multiple: true
      }, {
        name: 'Couture décousue complexe : réparation',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        id: '12.acce-rep-div-4',
        multiple: true
      }, {
        name: 'Passant (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 4,
          COMPLEX: 8
        },
        id: '12.acce-rep-div-5'
      }, {
        name: 'Doublure : réparation / remplacement',
        prices: {
          SIMPLE: 9,
          COMPLEX: 12
        },
        id: '12.acce-rep-div-7'
      }, {
        name: 'Poche (x1) : changement de doublure',
        prices: {
          SIMPLE: 17,
          COMPLEX: 19
        },
        id: '12.acce-rep-div-8'
      }, {
        name: 'Crochets (x1) : ajout / remplacement',
        prices: {
          SIMPLE: 6,
          COMPLEX: 8
        },
        id: '12.acce-rep-div-9'
      }]
    }]
  }, {
    name: 'Broder',
    slug: 'embroidery',
    subCategories: [(0, _commonPricings.getEmbroideryPricingsCategory)('acce', undefined)]
  }, {
    name: 'Divers',
    slug: 'divers',
    items: [{
      name: 'Doublure : ajout / remplacement',
      prices: {
        SIMPLE: 9,
        COMPLEX: 12
      },
      id: '12.acce-div-1'
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('acce', ['Doublure : ajout / remplacement']), 'div', 'acce', undefined, 1, true)))
  }]
}, {
  name: 'Décoration',
  slug: 'deco',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Rideaux',
    slug: 'ride',
    items: [{
      name: 'Ourlet - largeur <199cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '12.deco-rid-1',
      multiple: true
    }, {
      name: 'Ourlet - largeur >200cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '12.deco-rid-2',
      multiple: true
    }, {
      name: 'Supplément fil de plomb',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 10
      },
      id: '12.deco-rid-3',
      multiple: true
    }, {
      name: 'Assemblage côté - hauteur <199cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '12.deco-rid-4',
      multiple: true
    }, {
      name: 'Assemblage côté - hauteur >200cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 40
      },
      liningPrices: {
        DEFAULT: 10
      },
      id: '12.deco-rid-5',
      multiple: true
    }, {
      name: 'Ajout de fronces - largeur <199cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      id: '12.deco-rid-6',
      multiple: true
    }, {
      name: 'Ajout de fronces - largeur >200cm',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 37
      },
      id: '12.deco-rid-7',
      multiple: true
    }, {
      name: 'Dépose/pose d’un pan de rideau',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 7
      },
      id: '12.deco-rid-8',
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco'), 'rid', 'deco', 'SIMPLE', 8, true)))
  }, {
    name: 'Coussins',
    slug: 'cous',
    items: [{
      name: 'Coussin (moins de 45 cm)',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 14
      },
      id: '12.deco-cou-1',
      multiple: true
    }, {
      name: 'Coussin (plus de 45 cm)',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 18
      },
      id: '12.deco-cou-2',
      multiple: true
    }, {
      name: 'Doublure : ajout / remplacement',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 9
      },
      id: '12.deco-cou-3'
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'cou', 'deco', 'SIMPLE', 3, true)))
  }, {
    name: 'Linge de table',
    slug: 'tableClothes',
    items: _toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'nap', 'deco', 'SIMPLE', 3, true))
  }, {
    name: 'Housse de chaise',
    slug: 'chair',
    items: _toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'chai', 'deco', 'SIMPLE', 3, true))
  }, {
    name: 'Housse de canapé',
    slug: 'sofa',
    items: _toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco', ['Doublure : ajout / remplacement']), 'sofa', 'deco', 'SIMPLE', 3, true))
  }, {
    name: 'Linge de maison',
    slug: 'mais',
    items: [{
      name: 'Raccourcir longueur - plus d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      id: '12.deco-mai-1',
      multiple: true
    }, {
      name: 'Raccourcir largeur - plus d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      id: '12.deco-mai-2',
      multiple: true
    }, {
      name: 'Raccourcir longueur et largeur - plus d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 40
      },
      id: '12.deco-mai-3',
      multiple: true
    }, {
      name: 'Raccourcir longueur - moins d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 15
      },
      id: '12.deco-mai-4',
      multiple: true
    }, {
      name: 'Raccourcir largeur - moins d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 15
      },
      id: '12.deco-mai-5',
      multiple: true
    }, {
      name: 'Raccourcir longueur et largeur - moins d’1m60',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 30
      },
      id: '12.deco-mai-6',
      multiple: true
    }, {
      name: 'Raccourcir longueur - moins d’1m',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 10
      },
      id: '12.deco-mai-7',
      multiple: true
    }, {
      name: 'Raccourcir largeur - moins d’1m',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 10
      },
      id: '12.deco-mai-8',
      multiple: true
    }, {
      name: 'Raccourcir longueur et largeur - moins d’1m',
      isSuitableForJunior: true,
      prices: {
        DEFAULT: 20
      },
      id: '12.deco-mai-9',
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getPricingsItemsWithIds)((0, _commonPricings.getFilteredVariousPricingsItems)('deco'), 'mai', 'deco', 'SIMPLE', 9, true)))
  }, (0, _commonPricings.getEmbroideryPricingsCategory)('deco', 'SIMPLE'), (0, _commonPricings.getCommunMachineEmbroidery)({
    slug: 'deco'
  })]
}, {
  name: 'Autre',
  slug: 'autr',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Divers',
    slug: 'divers',
    items: [{
      name: '1h de conseil basique',
      prices: {
        DEFAULT: 20
      },
      id: '12.autr-div-1'
    }, {
      name: 'Prise de mesure',
      prices: {
        DEFAULT: 20
      },
      id: '12.autr-div-2'
    }, {
      name: '1h de conseil robe de mariée',
      prices: {
        DEFAULT: 60
      },
      id: '12.autr-div-3'
    }, {
      name: '1h de conseil tailleur',
      prices: {
        DEFAULT: 50
      },
      id: '12.autr-div-4'
    }, {
      name: '1h de conseil broderie, maille , sport & bain',
      prices: {
        DEFAULT: 30
      },
      id: '12.autr-div-5'
    }]
  }]
}, {
  name: 'Création de totebag',
  slug: 'crea_tote',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - classique : côtés < 50 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - classique : côtés < 50 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand : côtés > 51 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand : côtés > 51 cm'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Classique : côtés < 50 cm',
      prices: {
        SIMPLE_SMALL: 10
      }
    }, {
      name: 'Grand : côtés > 51 cm',
      prices: {
        SIMPLE_BIG: 15
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_BIG: 3
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_BIG: 2
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_tote',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 7
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 7
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_tote',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de sac',
  slug: 'crea_sac',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit : côtés < 35 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit : côtés < 35 cm'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Forme simple - moyen : 36 cm < côtés < 50 cm'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Forme originale - moyen : 36 cm < côtés < 50 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple : côtés > 51 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale : côtés > 51 cm'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit : côtés < 35 cm',
      prices: {
        SIMPLE_SMALL: 10
      }
    }, {
      name: 'Moyen : 36 cm < côtés < 50 cm',
      prices: {
        SIMPLE_MEDIUM: 15
      }
    }, {
      name: 'Grand : côtés > 51 cm',
      prices: {
        SIMPLE_BIG: 20
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_MEDIUM: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 5,
        SIMPLE_BIG: 5
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 5,
        SIMPLE_BIG: 5
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_sac',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_MEDIUM: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 6,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 6,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Clous de protection',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 10
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_sac',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de pochette',
  slug: 'crea_poch',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit (15x10cm)'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit (15x10cm)'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Forme simple - moyen (20x20cm)'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Forme originale - moyen (20x20cm)'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand (>25cm)'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand (>25cm)'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit 15x10cm',
      prices: {
        SIMPLE_SMALL: 7
      }
    }, {
      name: 'Moyen 20x20cm',
      prices: {
        SIMPLE_MEDIUM: 12
      }
    }, {
      name: 'Grand > 25cm',
      prices: {
        SIMPLE_BIG: 18
      }
    }]
  }, {
    name: 'Anses',
    slug: 'handles',
    autoIdPrefix: 'anse',
    items: [{
      name: 'Chaîne + oeillets',
      prices: {
        SIMPLE_SMALL: 15,
        SIMPLE_MEDIUM: 15,
        SIMPLE_BIG: 15
      }
    }, {
      name: 'Tissu',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_MEDIUM: 2,
        SIMPLE_BIG: 2
      }
    }, {
      name: 'Autre / fourni par le client',
      prices: {
        SIMPLE_SMALL: 2,
        SIMPLE_MEDIUM: 2,
        SIMPLE_BIG: 2
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_poch',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_MEDIUM: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_MEDIUM: 7,
        SIMPLE_BIG: 8
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_poch',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de housse de coussin',
  slug: 'crea_hous',
  autoId: true,
  hasMostCommonCategory: false,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Forme simple - petit (<45cm)'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Forme originale - petit (<45cm)'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Forme simple - grand (>45cm)'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Forme originale - grand (>45cm)'
  }],
  autoComplexFactor: 2,
  autoPrices: true,
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit < 45cm',
      prices: {
        SIMPLE_SMALL: 14
      }
    }, {
      name: 'Grand > 45cm',
      prices: {
        SIMPLE_BIG: 18
      }
    }]
  }, {
    name: 'Fermetures',
    slug: 'closures',
    autoIdPrefix: 'ferm',
    autoMultiple: true,
    items: (0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_hous',
      autoComplexFactor: 1,
      isClosingsOnly: true
    })
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 9,
        SIMPLE_BIG: 9
      }
    }, {
      name: 'Molleton',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 8
      }
    }, {
      name: 'Thermocollant',
      prices: {
        SIMPLE_SMALL: 5,
        SIMPLE_BIG: 8
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_hous',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Création de housse d’assise',
  slug: 'crea_assi',
  types: (0, _sofaCreation.getSeatAndBackTypes)(),
  subTypes: _sofaCreation.seatAndBackSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Passepoil',
      priceForAllTypes: 20,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_assi'
    })))
  }]
}, {
  name: 'Création de housse de dossier',
  slug: 'crea_doss',
  types: (0, _sofaCreation.getSeatAndBackTypes)(false),
  subTypes: _sofaCreation.seatAndBackSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Passepoil',
      priceForAllTypes: 20,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_doss'
    })))
  }]
}, {
  name: 'Création de housse de canapé',
  slug: 'crea_cana',
  types: (0, _sofaCreation.getSofaTypes)(),
  subTypes: _sofaCreation.sofaSubTypes,
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  categories: [{
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_cana'
    })))
  }]
}, {
  name: 'Création de plaid/couvre-lit',
  slug: 'crea_plai',
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Petit (côté inférieur à < 99cm)'
  }, {
    slug: 'MEDIUM',
    name: 'Moyen (côté inférieur à < 199cm)'
  }, {
    slug: 'BIG',
    name: 'Grand (côté inférieur à < 300cm)'
  }],
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit < 99cm',
      prices: {
        SMALL: 33
      }
    }, {
      name: 'Moyen < 199cm',
      prices: {
        MEDIUM: 54
      }
    }, {
      name: 'Grand < 300cm',
      prices: {
        BIG: 75
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    items: [{
      name: 'Doublure',
      prices: {
        SMALL: 5,
        MEDIUM: 12,
        BIG: 15
      }
    }, {
      name: 'Molleton fourni par le Tilliste',
      prices: {
        SMALL: 23,
        MEDIUM: 47,
        BIG: 76
      }
    }, {
      name: 'Molleton',
      prices: {
        SMALL: 13,
        MEDIUM: 17,
        BIG: 21
      }
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_plai'
    })))
  }]
}, {
  name: 'Création de housse de chaise',
  slug: 'crea_chai',
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Sans accoudoirs'
  }, {
    slug: 'BIG',
    name: 'Avec accoudoirs'
  }],
  categories: [{
    name: 'Accoudoirs',
    slug: 'armrests',
    autoIdPrefix: 'acco',
    items: [{
      name: 'Sans accoudoirs',
      prices: {
        SMALL: 34
      }
    }, {
      name: 'Avec accoudoirs',
      prices: {
        BIG: 64
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Housse jupe longue',
      priceForAllTypes: 12,
      multiple: true
    }, {
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_chai'
    })))
  }]
}, {
  name: 'Création de housse de tabouret/pouf',
  slug: 'crea_stoo',
  autoId: true,
  hasMostCommonCategory: false,
  autoPrices: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SMALL',
    name: 'Petit (grand côté < 50cm)'
  }, {
    slug: 'BIG',
    name: 'Grand (grand côté > 50cm)'
  }],
  categories: [{
    name: 'Dimensions',
    slug: 'sizes',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Petit (grand côté < 50cm)',
      prices: {
        SMALL: 26
      }
    }, {
      name: 'Grand (grand côté > 50cm)',
      prices: {
        BIG: 36
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Liens accoudoirs (x2)',
      priceForAllTypes: 15,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_stoo'
    })))
  }]
}, {
  name: 'Création de rideaux',
  slug: 'crea_ride',
  hasMostCommonCategory: false,
  autoId: true,
  isSuitableForJunior: true,
  types: [{
    slug: 'SIMPLE_SMALL',
    name: 'Un seul rideau - tringle < 140 cm'
  }, {
    slug: 'SIMPLE_MEDIUM',
    name: 'Un seul rideau - tringle < 200 cm'
  }, {
    slug: 'SIMPLE_BIG',
    name: 'Un seul rideau - tringle < 300 cm'
  }, {
    slug: 'SIMPLE_HUGE',
    name: 'Un seul rideau - tringle < 400 cm'
  }, {
    slug: 'COMPLEX_SMALL',
    name: 'Paire de rideaux - tringle < 140 cm'
  }, {
    slug: 'COMPLEX_MEDIUM',
    name: 'Paire de rideaux - tringle < 200 cm'
  }, {
    slug: 'COMPLEX_BIG',
    name: 'Paire de rideaux - tringle < 300 cm'
  }, {
    slug: 'COMPLEX_HUGE',
    name: 'Paire de rideaux - tringle < 400 cm'
  }],
  autoComplexFactor: 1,
  autoPrices: true,
  categories: [{
    name: 'Longueur rideau',
    slug: 'ride_length',
    autoIdPrefix: 'dime',
    items: [{
      name: 'Tringle < 140 cm',
      prices: {
        SIMPLE_SMALL: 50
      },
      autoComplexFactor: 1.4
    }, {
      name: 'Tringle < 200 cm',
      prices: {
        SIMPLE_MEDIUM: 80
      },
      autoComplexFactor: 1.25
    }, {
      name: 'Tringle < 300 cm',
      prices: {
        SIMPLE_BIG: 120
      },
      autoComplexFactor: 1.25
    }, {
      name: 'Tringle < 400 cm',
      prices: {
        SIMPLE_HUGE: 150
      },
      autoComplexFactor: 1.2
    }]
  }, {
    name: 'Hauteur rideau',
    slug: 'ride_height',
    autoIdPrefix: 'haut',
    items: [{
      name: 'Court (hauteur < à 200 cm)',
      prices: {
        SIMPLE_SMALL: 0,
        SIMPLE_MEDIUM: 0,
        SIMPLE_BIG: 0,
        SIMPLE_HUGE: 0
      }
    }, {
      name: 'Moyen (hauteur < à 300 cm)',
      prices: {
        SIMPLE_SMALL: 10,
        SIMPLE_MEDIUM: 20,
        SIMPLE_BIG: 30,
        SIMPLE_HUGE: 40
      }
    }, {
      name: 'Long (hauteur < à 400 cm)',
      prices: {
        SIMPLE_SMALL: 14,
        SIMPLE_MEDIUM: 28,
        SIMPLE_BIG: 42,
        SIMPLE_HUGE: 56
      }
    }]
  }, {
    name: 'Tête de rideau',
    slug: 'ride_head',
    autoIdPrefix: 'tete',
    items: [{
      name: 'Ruban passants cachés',
      prices: {
        SIMPLE_SMALL: 30,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 37,
        SIMPLE_HUGE: 37
      }
    }, {
      name: 'Pattes apparentes',
      prices: {
        SIMPLE_SMALL: 56,
        SIMPLE_MEDIUM: 80,
        SIMPLE_BIG: 120,
        SIMPLE_HUGE: 160
      }
    }, {
      name: 'Galon fronceur',
      prices: {
        SIMPLE_SMALL: 30,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 37,
        SIMPLE_HUGE: 37
      }
    }, {
      name: 'Nouettes',
      prices: {
        SIMPLE_SMALL: 56,
        SIMPLE_MEDIUM: 80,
        SIMPLE_BIG: 120,
        SIMPLE_HUGE: 160
      }
    }]
  }, {
    name: 'Suppléments / toppings',
    slug: 'extras',
    autoIdPrefix: 'supp',
    autoMultiple: true,
    items: [{
      name: 'Doublure',
      prices: {
        SIMPLE_SMALL: 20,
        SIMPLE_MEDIUM: 30,
        SIMPLE_BIG: 40,
        SIMPLE_HUGE: 50,
        COMPLEX_SMALL: 30,
        COMPLEX_MEDIUM: 40,
        COMPLEX_BIG: 50,
        COMPLEX_HUGE: 60
      }
    }, {
      name: 'Supplément fil de plomb',
      priceForAllTypes: 10,
      multiple: true
    }, {
      name: 'Dépose/pose d’un pan de rideau',
      priceForAllTypes: 10,
      multiple: true
    }].concat(_toConsumableArray((0, _commonPricings.getVariousPricingsItemsForCreation)({
      slug: 'crea_ride',
      autoComplexFactor: 1
    })))
  }]
}, {
  name: 'Masque',
  slug: 'mask',
  hasMostCommonCategory: false,
  types: undefined,
  categories: [{
    name: 'Fabrication',
    slug: 'fabrication',
    items: [{
      name: 'Masque en tissu',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-1'
    }, {
      name: 'Masque en tissu adulte bleu avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-2'
    }, {
      name: 'Masque en tissu adulte beige avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-3'
    }, {
      name: 'Masque en tissu enfant bleu avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-4'
    }, {
      name: 'Masque en tissu enfant beige avec lanières',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-5'
    }, {
      name: 'Masque en tissu adulte bleu avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-6'
    }, {
      name: 'Masque en tissu adulte beige avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-7'
    }, {
      name: 'Masque en tissu enfant bleu avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-8'
    }, {
      name: 'Masque en tissu enfant beige avec élastiques',
      prices: {
        DEFAULT: 10
      },
      id: '12.mask-fab-9'
    }]
  }]
}];
var _default = exports["default"] = rawPricing;